import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { GeneralWarningModalComponent } from './general-warning-modal.component';

@NgModule({
  declarations: [GeneralWarningModalComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  exports: [GeneralWarningModalComponent]
})
export class GeneralWarningModalModule { }
